var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-[#FEDB00] pt-[18px] flex items-center"},[_c('img',{staticClass:"ml-[32px] mb-[14px] mr-auto",attrs:{"src":require("assets/images/hogcone_logo.png"),"alt":"hogc one logo"}}),_vm._v(" "),_c('img',{staticClass:"mr-[24px] mb-[20px]",attrs:{"src":require("assets/icons/logo-heart-cross.svg"),"alt":"hogc logo"}})])
}]

export { render, staticRenderFns }